<template>
  <div class="quiz_question">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'QuizQuestion'
}
</script>

<style scoped>
  .quiz_question {
    width: 372px;
    height: 286px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  @media screen and (max-width: 767px) {
    .quiz_question {
      width: 100%;
      height: 100%;
      margin-top: 3%;
    }
  }
  @media screen and (max-width: 767px) {
    .quiz_explain > .quiz_question {
      order: -1;
    }
  }

</style>
